import React from "react";
import PropTypes from "prop-types"; // eslint-disable-line
import { makeStyles } from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import ClearIcon from '@material-ui/icons/Clear';

const useStyles = makeStyles({
  root: {
    background: "#000",
    color: "#fff",
    minHeight: "56px"
    //padding: "0 23px"
  },
  back: {
    padding: "24px 23px",
    fill: "#fff",
    background: "#DE2635"
  },
  backSvg: {
    height: "17px",
    width: "auto"
  },
  title: {
    fontSize: 16,
    paddingLeft: "10px",
  },
  fav: {
    padding: "21px 23px",
    stroke: "#fff",
    fill: "#fff"
  },
  active: {
    stroke: "#FFC400",
    fill: "#FFC400"
  },
  empty: {
    width: "55px"
  },
  inPageButton: {
    padding: "10px",
    color: "#ddd",
    "&:hover": {
      color: "#fff"
    }
  }
});

const ModalHeader = props => {
  const classes = useStyles();
  const {
    title,
    type,
    id,
    goBack,
    children,
    align,
    className
  } = props; // eslint-disable-line

  let actionButton = <div className={classes.empty}>&nbsp;</div>;

  return (
    <div
      id={id}
      className={`${classes.root} d-flex flex-row flex-nowrap ${align === "start" ? 'align-items-start' : 'align-items-center'} justify-content-between match-prematch-header match-modal-top ${className ? className : ''}`}
    >
      {children !== null ? (
        children
      ) : (
          <React.Fragment>
            <div className={classes.title}>{title}</div>
            <div>{actionButton}</div>
          </React.Fragment>
        )}
      <div>
        {type !== "inPage" && <ButtonBase className={classes.back} onClick={goBack}>
          <ClearIcon className={classes.backSvg} />
        </ButtonBase>}
        {type === "inPage" && <ButtonBase className={classes.inPageButton} onClick={goBack}>
          <HighlightOffOutlinedIcon />
        </ButtonBase>}
      </div>
    </div>
  );
};

ModalHeader.propTypes = {
  title: PropTypes.string,
  id: PropTypes.string,
  active: PropTypes.bool,
  type: PropTypes.string,
  goBack: PropTypes.func,
  onAction: PropTypes.func,
  children: PropTypes.node
};

ModalHeader.defaultProps = {
  title: "Title",
  id: "_id_",
  active: false,
  type: "fav",
  goBack: () => { },
  onAction: () => { },
  children: null
};

export default ModalHeader;
